export default __webpack_public_path__ + "static/media/teamwork.4e184b25.png";